import { render, staticRenderFns } from "./ResolveTicket.vue?vue&type=template&id=6af45de6&scoped=true&"
import script from "./ResolveTicket.vue?vue&type=script&lang=js&"
export * from "./ResolveTicket.vue?vue&type=script&lang=js&"
import style0 from "./ResolveTicket.vue?vue&type=style&index=0&id=6af45de6&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6af45de6",
  null
  
)

export default component.exports